import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

// Display all Docket List
export const getDocketList = createAsyncThunk('data/docket',
  async(data)=>{
    let url = `/api/v1/docket/getDocketDetails?page=${data.page}&limit=${data.limit}`;
    if(data.search) url += `&search=${data.search}`;
    const res = await axiosInstance.get(url);
      return res.data
  }
)

// Display Docket Tracking 
export const trackDocketId = createAsyncThunk('data/trackDocketId',
  async(data)=>{
    const res = await axiosInstance.get(`/api/v1/track/${data}`);
      return res.data
  }
)
export const fetchAndOpenDocketPdf = createAsyncThunk(
  "pdf/fetchAndOpenDocketPdf",
  async (DocketId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/api/v1/docket/SearchDocketDetailsByDocketId`,
        {
          DocketId, // ✅ request body me DocketId bhej rahe
        }
      );

      const pdfUrl = response?.data?.pdfUrl;

      if (pdfUrl) {
        window.open(pdfUrl, "_blank");
        return pdfUrl;
      } else {
        return rejectWithValue("PDF URL not found");
      }
    } catch (err) {
      console.error("❌ API Error:", err.response);
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong"
      );
    }
  }
);


